import type { CustomerNewOrderTask as NewOrderTask } from '@einwert/valuation-api-client'
import { useCreateTaskForOrder } from 'ClientPortal/src/api/Queries/tasks'
import { useIamContext } from 'ClientPortal/src/context/IAmContext'
import { useTypedParams } from 'ClientPortal/src/router/useTypedParams'

import { localFormatToIsoDateString } from 'ComponentLibrary/src/common/date'
import { useGetUsers } from 'ClientPortal/src/api/Queries/users'

export const useCreateNewTaskData = ({ onSuccess }: { onSuccess?: () => void }) => {
    const { orderId } = useTypedParams(['orderId'])
    const { user } = useIamContext()
    const { users, isUsersPending } = useGetUsers({ orderId })
    const { createTaskAsync, isCreatingTask, isCreateTaskError } = useCreateTaskForOrder({ userId: user?.id, onSuccess })

    const createNewTask = async (task: Omit<NewOrderTask, 'order_uuid'>) => {
        await createTaskAsync({
            ...task,
            order_uuid: orderId,
            due_date: task.due_date ? localFormatToIsoDateString(task.due_date) : undefined,
        })
    }

    return {
        createNewTask,
        isCreatingTask,
        isCreateTaskError,
        users,
        isUsersPending,
    }
}
